import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import IconButton from "../../../packages/IconButton";
import WPButton from "../../../packages/WPButton";

import AssignLicense from "../AssignLicense";
import LicenseSearchFilter from "./LicenseSearchFilter";

import { LICENSE_STATUS_ICONS } from "../../../constants/LicenseManagement.constants";

import { DataAppendIcon } from "../../../assets/icons";

import IconWithTooltip from "../../../common/styles/components/headings/IconWithTooltip";

import "./LicenseManagementHeader.scss";

const LicenseManagementHeader = ({
  updateLicensePayload,
  licensePayload,
  onUserLicenseUpdate,
  onExportUserLicenses,
}) => {
  const { t } = useTranslation();
  const [openAssignLicenseModal, setOpenAssignLicenseModal] = useState(false);

  const licenseStatusIconsConfig = useMemo(
    () =>
      LICENSE_STATUS_ICONS.map((item) => ({ ...item, label: t(item.label) })),
    [t],
  );

  const tooltipLegend = (
    <div className="license-legend-container">
      {licenseStatusIconsConfig.map((item) => (
        <div key={item.label} className="license-legend-item">
          {item.icon}
          <span>{item.label}</span>
        </div>
      ))}
    </div>
  );

  const handleAssignLicense = () => {
    setOpenAssignLicenseModal(true);
  };

  const closeAssignLicenseModal = () => {
    setOpenAssignLicenseModal(false);
  };

  return (
    <div className="lic-header-container">
      <div className="lic-title-section">
        <div className="info-section">
          <span className="lic-title">{t("licenseManagement.title")}</span>
          <IconWithTooltip label={tooltipLegend} placement="right" />
        </div>
        <div className="lic-description">{t("licenseManagement.info")}</div>
      </div>
      <div className="lic-actions-section">
        <LicenseSearchFilter
          updateLicensePayload={updateLicensePayload}
          currentSearch={licensePayload?.searchstr ?? ""}
        />
        <WPButton
          id="assign-license-btn"
          variant="contained"
          onClick={handleAssignLicense}
        >
          {t("licenseManagement.assignLicense")}
        </WPButton>
        <IconButton
          id="export-btn"
          onClick={onExportUserLicenses}
          tooltip={t("ValueStrings.export")}
        >
          <DataAppendIcon width="20px" height="20px" />
        </IconButton>
      </div>
      {openAssignLicenseModal && (
        <AssignLicense
          onCloseModal={closeAssignLicenseModal}
          onUserLicenseUpdate={onUserLicenseUpdate}
        />
      )}
    </div>
  );
};

export default LicenseManagementHeader;
